import { ReactElement, useEffect, useState } from "react";
import i18next from "i18next";
import { LanguageContext } from "@/context";

import "@/locale/i18n";

export default function LanguageProvider({ children }: any): ReactElement {
  const [locale, setLocale] = useState(
    localStorage.getItem("@trioEducationPwa/locale") ?? "en",
  );
  const direction = ["fa", "ar"].includes(locale) ? "rtl" : "ltr";

  useEffect(() => {
    locale && localStorage.setItem("@trioEducationPwa/locale", locale);
    i18next.changeLanguage(locale);
  }, [locale]);

  return (
    <LanguageContext.Provider value={{ locale, changeLocale: setLocale }}>
      <div dir={direction}>{children}</div>
    </LanguageContext.Provider>
  );
}
